import { ComponentResource } from '@/api/serverApi'
import { useMemo } from 'react'

const channelProperties = {
  strokeWidth: 1,
  fillColour: '#757575',
  strokeColour: 'black',
}

const anchorProperties = {
  radius: 3,
  fillColour: '#757575',
  strokeColour: 'black',
  strokeDash: '2,2',
}

type PropTypes = {
  height: number,
  width: number,
  xOffset?: number,
  yOffset?: number,
  channel: ComponentResource,
}

const TopDownChannel = ({ height, width, xOffset = 0, yOffset = 0, channel }: PropTypes) => {
  const innerChannelHeight = useMemo(() => height / 2, [height])
  const innerChannelOffset = useMemo(() => yOffset + (innerChannelHeight / 2), [innerChannelHeight, yOffset])

  const castInChannel = useMemo(() => channel.cast_in_anchor_channel, [channel])
  const channelLength = useMemo(() => castInChannel?.length, [castInChannel])
  const anchorSpacings = useMemo(() => castInChannel?.anchor_spacings, [castInChannel])

  const relativeAnchorSpacings = useMemo(() => {
    if (anchorSpacings && channelLength) {
      return anchorSpacings.map(spacing => spacing / channelLength)
    }

    return []
  }, [anchorSpacings, channelLength])

  return (
    <g>
      <rect
        x={xOffset}
        y={yOffset}
        width={width}
        height={height}
        stroke={channelProperties.strokeColour}
        fill={channelProperties.fillColour}
        strokeWidth={channelProperties.strokeWidth}
      />
      <rect
        x={xOffset}
        y={innerChannelOffset}
        width={width}
        height={innerChannelHeight}
        stroke={channelProperties.strokeColour}
        fill={channelProperties.fillColour}
        strokeWidth={channelProperties.strokeWidth}
      />

      {
        relativeAnchorSpacings.map((spacing, index) =>
          (
            <circle
              key={index}
              cx={xOffset + (width * spacing)}
              cy={yOffset + (height / 2)}
              r={anchorProperties.radius}
              fill={anchorProperties.fillColour}
              stroke={anchorProperties.strokeColour}
              strokeWidth={channelProperties.strokeWidth}
              strokeDasharray={anchorProperties.strokeDash}
            />
          ),
        )
      }
    </g>
  )
}

export default TopDownChannel
